import { Badge } from '@components/badge';
import { BADGE_VARIANT_GRAY_DISABLED, Variant } from '@components/badge/src/badge.type';
import { IconPerson, IconTicket, IconTime, IconTrigger } from '@components/icons';
import { Tooltip } from '@components/tooltip';
import { ADMISSION_STATUS_HIDDEN_BY_TRIGGER } from '@domain/admission';
import { formatValue } from '@utils/price-formatter/price-formatter';

import { AdmissionCardBadgesProps, TAG_TRANSLATION_KEYS, TAG_VARIANT } from '../src/admission-card.type';

export const AdmissionCardBadges = ({
  status,
  badgeVariant,
  statusTranslated,
  tags,
  accessValidity,
  guestCapacity,
  cardOpacity,
  soldItems,
  quantity,
  t,
}: AdmissionCardBadgesProps) => {
  return (
    <div className='flex gap-2 flex-wrap mt-1 sm:mt-2'>
      {badgeVariant !== '' && statusTranslated && (
        <Badge variant={badgeVariant} squared className='px-3 py-1 max-h-6 cursor-pointer'>
          <div className='flex items-center'>
            {status === ADMISSION_STATUS_HIDDEN_BY_TRIGGER && (
              <span className='mr-1'>
                <IconTrigger className='w-[14px]' />
              </span>
            )}
            {statusTranslated}
          </div>
        </Badge>
      )}
      {tags.map((tag) => {
        const variant = TAG_VARIANT[tag] as Variant;
        const tagKey = TAG_TRANSLATION_KEYS[tag];

        return (
          <Badge key={tag} variant={variant} squared className='px-3 py-1 max-h-6 cursor-pointer'>
            {t(tagKey)}
          </Badge>
        );
      })}
      {!!accessValidity && (
        <Tooltip
          button={
            <Badge variant={BADGE_VARIANT_GRAY_DISABLED} squared className='pl-2 pr-3 py-0.5 cursor-pointer max-h-6'>
              <span className={`flex items-center ${cardOpacity}`}>
                <IconTime className='mr-1 w-5 h-5' />
                <span className='text-body-xs align-middle'>{accessValidity}</span>
              </span>
            </Badge>
          }
          popoverContent={
            <div className='flex gap-1 bg-inverse p-4 pl-3 relative rounded-lg'>
              <IconTime className='w-5 h-5 text-tertiary' />
              <div className='flex flex-col gap-2'>
                <span className='text-tertiary text-body-s'>{t('offers:admissionAccessValidityLabel')}</span>
                <span className='text-tertiary text-body-s'>{accessValidity}</span>
              </div>
            </div>
          }
        />
      )}
      {!!guestCapacity && (
        <Badge variant={BADGE_VARIANT_GRAY_DISABLED} squared className='pl-2 pr-3 py-0.5 cursor-pointer max-h-6'>
          <span className={`flex items-center ${cardOpacity}`}>
            <IconPerson className='mr-1 w-5 h-5' />
            <span className='text-body-xs'>{guestCapacity}</span>
          </span>
        </Badge>
      )}
      <Badge variant={BADGE_VARIANT_GRAY_DISABLED} squared className='pl-2 pr-3 py-0.5 cursor-pointer max-h-6'>
        <span className={`flex items-center ${cardOpacity}`}>
          <IconTicket className='mr-1 w-5 h-5' />
          <span className='text-body-xs whitespace-nowrap'>
            {formatValue({ number: soldItems })}/{quantity === null ? '∞' : formatValue({ number: quantity })}
          </span>
        </span>
      </Badge>
    </div>
  );
};
